import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.9453 2.14062C11.2734 2.39844 11.3438 2.86719 11.1094 3.19531L5.10938 11.4453C4.96875 11.6094 4.78125 11.7266 4.57031 11.75C4.33594 11.7734 4.125 11.6797 3.96094 11.5391L0.960938 8.53906C0.679688 8.23438 0.679688 7.76562 0.960938 7.46094C1.26562 7.17969 1.73438 7.17969 2.03906 7.46094L4.40625 9.85156L9.89062 2.30469C10.1484 1.97656 10.6172 1.90625 10.9453 2.14062Z",
		fill: "currentColor"
	})
});
export default SvgIconCheck;
